import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetRespondentColumnNamesRPC } from "./getRespondentColumnNamesRPC";

export class GetRespondentColumnNamesRPCClientImpl extends GetRespondentColumnNamesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetRespondentColumnNamesRPC.Request): Promise<LeoRPCResult<GetRespondentColumnNamesRPC.Response, GetRespondentColumnNamesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/GetRespondentColumnNames",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetRespondentColumnNamesRPC.ResponseDTO,
      GetRespondentColumnNamesRPC.Errors.ErrorsDTO,
      GetRespondentColumnNamesRPC.Response,
      GetRespondentColumnNamesRPC.Errors.Errors
    >(
      response,
      "project/GetRespondentColumnNames",
      GetRespondentColumnNamesRPC.Response.fromDTO,
      GetRespondentColumnNamesRPC.Errors.fromDTO
    );
  }
}
